define('realtime',[
  'common/module/realtime/Serum.RealtimeUpdater',
  'common/module/realtime/Serum.RelationalRealtimeWidget',
  'common/module/realtime/Serum.RealtimeEventEmitter',
  'common/module/realtime/Serum.SseEventEmitter',
  'common/module/realtime/Serum.RealtimeWidget',
  'common/module/date/Serum.Clock',
  'type/stream/Serum.RealtimeStream',
  'type/compilation/Compilation',
  'type/compilation/CompilationStatus',
  'skin/newsroom/tinycon',
  'skin/newsroom/Serum.Newsroom'
],function(){

});

